import { CheckOutlined/* , CloseOutlined */ } from "@ant-design/icons"
import { Space, Tag, Tooltip } from "antd"
import { FormItemProps } from "antd/lib/form"
import pick from 'ramda/src/pick'
import * as sourceData from 'src/data'

export const mapColumn = (sourceColumn: any) => {

    const column = pick<any, any>(['key', 'title', 'type', 'values'], sourceColumn)

    if(sourceColumn.tip) {
        column.title = <Tooltip title={sourceColumn.tip}>{column.title}</Tooltip>
    }
    if(column.type === 'radio') {
        const isTrueOrFalse = column.values.length === 2
        return {
            ...column,
            dataIndex: column.key,
            render: (props: any) => {
                if(isTrueOrFalse) {
                    return <div>
                        {props?.toString() === '1' ? <CheckOutlined /> : null}
                    </div>
                }

                let values = column.values
                

                if(typeof values === 'string') {
                    values = (sourceData as any)[column.values]
                }
                return <div>
                    {values.find((v: any) => v.key === props?.toString())?.title}
                </div>
            }
        }
    } else if(column.type === 'checkbox') {
        return {
            ...column,
            dataIndex: column.key,
            render: (ids: any) => {
                let values = column.values

                if(typeof values === 'string') {
                    values = (sourceData as any)[column.values]
                }

                return <Space wrap size={[0,4]}>
                    {ids.split(',').map((id: string) => {
                        const type = values.find((v: any) => v.key === id)
                        return <Tag key={type ? type.key : id}>{type ? type.title : id}</Tag>
                    })}
                </Space>
            }
        }
    }
    return {
        ...column,
        dataIndex: column.key
    }
}

export const mapFormItemToProps = (props: FormAttribute) => {
    let { values, options,allowClear,type, disabled = false, rules = [{ 
        required: true
    },{
        validator: (rule: any, value: any) => {
            // console.log( value.trim?.() ?? value)
            if(value?.trim?.() ?? value) {
                return Promise.resolve()
            } else {
                return Promise.reject(`'${props.key}' is required`)
            }
        }
    }] } = props
    const label = props.tip ?
        <Tooltip className="under-dashed" title={props.tip}>{props.title}</Tooltip> :
        props.title

    const formItemProps: FormItemProps = {
        ...({
            key: props.key,
            label,
            name: props.key,
            validateFirst: true,
            initialValue: props.defaultValue,
            rules,
        }),
        hidden: type === 'hidden'
    }

    if(props.contentExtra) {
        formItemProps.extra = props.contentExtra
    }
    
    if(typeof values === 'string') {
        values = (sourceData as any)[values]
    }

    const formItemContentProps = { 
        values, 
        options,
        type,
        disabled: disabled,
        placeholder: props.placeholder,
        allowClear
    }

    return {
        formItemProps,
        formItemContentProps
    }
}